import { gql } from '@apollo/client';

export const CREATE_ALLOCATION_PLAN = gql`
  mutation CreateAllocationPlan($portfolioId: ID!, $name: String!, $allocations: [AllocationItemInput!]!) {
    createAllocationPlan(portfolioId: $portfolioId, name: $name, allocations: $allocations) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          coingeckoApiId
          coingeckoSlug
        }
        amount
        completed
        targetLocation {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ALLOCATION_PLAN = gql`
  mutation UpdateAllocationPlan($planId: ID!, $name: String, $allocations: [AllocationItemInput!]) {
    updateAllocationPlan(planId: $planId, name: $name, allocations: $allocations) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          coingeckoApiId
          marketData {
            currentPrice
            priceChange24h
            marketCap
          }
        }
        amount
        completed
        targetLocation {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_ALLOCATION_PLAN = gql`
  mutation DeleteAllocationPlan($planId: ID!) {
    deleteAllocationPlan(planId: $planId)
  }
`;

export const ADD_TOKEN_TO_RECENT_PLAN = gql`
  mutation AddTokenToRecentPlan($portfolioId: ID!, $tokenId: ID!, $amount: String!) {
    addTokenToRecentPlan(portfolioId: $portfolioId, tokenId: $tokenId, amount: $amount) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          coingeckoApiId
          coingeckoSlug
        }
        amount
      }
      createdAt
      updatedAt
    }
  }
`; 

export const ADD_TOKEN_TO_PLAN = gql`
  mutation AddTokenToPlan($planId: ID!, $amount: String!, $tokenId: ID, $coingeckoApiId: String) {
    addTokenToPlan(planId: $planId, amount: $amount, tokenId: $tokenId, coingeckoApiId: $coingeckoApiId) {
      id
      name
      allocations {
        token {
          id
          name
          ticker
          coingeckoApiId
          coingeckoSlug
        }
        amount
        completed
        targetLocation {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;